var _defs, _style, _use;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLikeWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 35 30",
    width: 35,
    height: 30,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("image", {
    width: 35,
    height: 30,
    id: "img1",
    href: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACMAAAAeCAMAAACR41cYAAAAAXNSR0IB2cksfwAAARRQTFRF////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////qovlLgAAAFx0Uk5TABqS4OWgKhbJ/yYBo5dpzQI279AEEc7PnWcz6xweHdQgGwh34+fm3VuN+uG2XdGoC8WQzKIMwsuhwel8/UHWGf5oJbItOsbIKEmlgzVWpD5V2d4XDaYKLmvSU3HwVtM1AAABGklEQVR4nK3UaVPCMBAG4BfBYw2KghY8Ws/WkyoCgopaLxBvvKv//3+YkM7Q0abhg++nne0zs5nJNsDvJAaSqcGhP+1whkeIJzkaQ1iauhmLMeOSUGZCSSazgclNqci0ERDKK02BtGaGtGZ2rmeM8Ac2b1qWmRCHyfQILSxaPObSsjArq7bj2GvrYBshQptOyuH9re0iN67s7WC3RJHZYyjLqoLqfrShImqyqKN6oDClPsxhH8b+p1lHetM41puTU72pM63xziCM58WY7LkwF5dXTbVp8TstN66BNt2ozK0w3h1wTw8q8wgxq9V+6ihnPb9wEyxfBa+Ru1EQ/1lO1m94b0aQzofY1c+877p+7Qv4dnkVjm+ku2/DD8kVOh7P5pt8AAAAAElFTkSuQmCC"
  }))), _style || (_style = /*#__PURE__*/React.createElement("style", null)), _use || (_use = /*#__PURE__*/React.createElement("use", {
    href: "#img1",
    x: 0,
    y: 0
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLikeWhite);
export default __webpack_public_path__ + "static/media/likeWhite.17fb4e8bc9773827ea44080e9084c36f.svg";
export { ForwardRef as ReactComponent };